import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { setLoading } from "../../store/reducers/ui";

export const useGlobalLoading = (isLoading: boolean) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLoading(isLoading));

    return () => {
      dispatch(setLoading(false));
    };
  }, [dispatch, isLoading]);
};
